var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 2.83337H3.54167C2.75926 2.83337 2.125 3.46764 2.125 4.25004V12.75C2.125 13.5324 2.75926 14.1667 3.54167 14.1667H13.4583C14.2407 14.1667 14.875 13.5324 14.875 12.75V4.25004C14.875 3.46764 14.2407 2.83337 13.4583 2.83337Z",
    stroke: "currentColor",
    strokeWidth: 1.275,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02083 7.86249C6.64675 7.86249 7.15416 7.35508 7.15416 6.72916C7.15416 6.10324 6.64675 5.59583 6.02083 5.59583C5.39491 5.59583 4.8875 6.10324 4.8875 6.72916C4.8875 7.35508 5.39491 7.86249 6.02083 7.86249Z",
    stroke: "currentColor",
    strokeWidth: 1.275,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83333 12.0417L6.37499 8.5L9.20833 11.3333L11.3333 9.20833L14.1667 12.0417",
    stroke: "currentColor",
    strokeWidth: 1.275,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.13538dbac5333adc361e5d874c8fc246.svg";
export { ForwardRef as ReactComponent };